/*
 * Run function after window resize
 * http://stackoverflow.com/questions/2854407/javascript-jquery-window-resize-how-to-fire-after-the-resize-is-completed
 */
var afterResize = (function () {
  var t = {};
  return function (callback, ms, uniqueId) {
    if (!uniqueId) {
      uniqueId = "Don't call this twice without a uniqueId";
    }
    if (t[uniqueId]) {
      clearTimeout(t[uniqueId]);
    }
    t[uniqueId] = setTimeout(callback, ms);
  };
})();

/* cart */
const cartDrawerSelector = '#CartDrawer';
const cartOpenClass = 'cart-open';

var toggleCart = function() {
  $(cartDrawerSelector).toggleClass(cartOpenClass);
}

var showCart = function() {
  if (!$(cartDrawerSelector).hasClass(cartOpenClass)) {
    toggleCart();
  }
}


/* conjured */
var conjuredReferralExternal = function() {
  const filledClass = 'filled';

  $('.form input:not([type=submit]):not([type=checkbox]):not([type=hidden]), .form textarea').focus(function() {
    $(this).addClass(filledClass);
  }).blur(function() {
    if ($(this).val().length == 0) {
      $(this).removeClass(filledClass);
    }
  }).each(function() {
    if ($(this).val().length > 0) {
      $(this).addClass(filledClass);
    }
  });
}


$(function() {

  feather.replace();

  let setAccordian = function(namespace) {
    $('.' + namespace + '-toggle').click(function(e) {
      e.preventDefault();
      var $body = $(this).closest('.' + namespace + '-wrapper').find('.' + namespace + '-body');
      var $i = $(this).find('i');
      const openedIconClass = 'fa-angle-up';
      const closedIconClass = 'fa-angle-down';
      const hiddenClass = namespace + '-hidden';
  
      if ($body.hasClass(hiddenClass)) {
        // open this, close others
        var $opened = $(this).closest('.' + namespace + '-list').find('.' + namespace + '-body:not(.' + hiddenClass + ')');
        if ($opened.length) {
          $opened.closest('.' + namespace + '-wrapper').find('i').removeClass(openedIconClass).addClass(closedIconClass);
          $opened.addClass(hiddenClass).slideUp();
        }
    
        $body.removeClass(hiddenClass).slideDown();
        $i.removeClass(closedIconClass).addClass(openedIconClass);
      } else {
        $body.addClass(hiddenClass).slideUp();
        $i.removeClass(openedIconClass).addClass(closedIconClass);
      }
    });
  }

  /* faqs */
  setAccordian('faq');

  setAccordian('additional-info');
  
  
  // $('.faq-toggle').click(function(e) {
  //   e.preventDefault();
  //   var $body = $(this).closest('.faq-wrapper').find('.faq-body');
  //   var $i = $(this).find('i');
  //   const openedIconClass = 'fa-angle-up';
  //   const closedIconClass = 'fa-angle-down';
  //   const hiddenClass = 'faq-hidden';

  //   if ($body.hasClass(hiddenClass)) {
  //     // open this, close others
  //     var $opened = $(this).closest('.faq-list').find('.faq-body:not(.' + hiddenClass + ')');
  //     if ($opened.length) {
  //       $opened.closest('.faq-wrapper').find('i').removeClass(openedIconClass).addClass(closedIconClass);
  //       $opened.addClass(hiddenClass).slideUp();
  //     }
  
  //     $body.removeClass(hiddenClass).slideDown();
  //     $i.removeClass(closedIconClass).addClass(openedIconClass);
  //   } else {
  //     $body.addClass(hiddenClass).slideUp();
  //     $i.removeClass(openedIconClass).addClass(closedIconClass);
  //   }
  // });





  /* product page */
  $('.btn-minus').click(function(e) {
    e.preventDefault();
    const input = $(e.target).closest('.input-group').find('input');
    input[0].stepDown();
  });

  $('.btn-plus').click(function(e) {
    e.preventDefault();
    const input = $(e.target).closest('.input-group').find('input');
    input[0].stepUp();
  });

  $('.variants input[type=radio][name=id]').change(function() {
    var variantId = this.value;
    console.log(variantId);

    $('.product-price').hide();
    $('#price-for-' + variantId).show();

  });

  var thumbnailSelector = '.product-thumbnail';
  var currentThumbnailClass = 'current';

  $(thumbnailSelector).click(function() {
    $this = $(this);

    if ($this.hasClass(currentThumbnailClass)) return;

    $(thumbnailSelector).removeClass(currentThumbnailClass);
    $this.addClass(currentThumbnailClass);

    $('.product-page__product-image>img').prop('src', $this.data('img-src'));
  });


  

  
  $('.drawer-close-button, .cart-link').click(function() {
    toggleCart();
    return false;
  });

  $('[data-cart-submit=data-cart-submit], .add-to-cart-form').submit(function() {
    showCart();
  });

  if (window.location.hash == '#cart') {
    showCart();
  }

  /* forms - input style */
  const filledClass = 'filled';

  $('.form input:not([type=submit]):not([type=checkbox]):not([type=hidden]), .form textarea').focus(function() {
    $(this).addClass(filledClass);
  }).blur(function() {
    if ($(this).val().length == 0) {
      $(this).removeClass(filledClass);
    }
  }).each(function() {
    if ($(this).val().length > 0) {
      $(this).addClass(filledClass);
    }
  });

  /* password recover */
  var showRecoverPasswordForm = function() {
    $('.recover-password-form-wrapper').show();
    $('.login-form-wrapper').hide();
  }

  var showLoginForm = function() {
    $('.login-form-wrapper').show();
    $('.recover-password-form-wrapper').hide();
    
  }

  $('#RecoverPassword').click(function() {
    showRecoverPasswordForm();
    return false;
  });

  $('#BackToLogin').click(function() {
    showLoginForm();
    return false;
  });

  if ($('.recover-password-form-wrapper p.success').length > 0 || window.location.hash == '#recover')  {
    showRecoverPasswordForm();
  }
  
  /* shop page underline animation */
  const target = $('.target');
  const shopNavlinks = $('.nav-items li');

  var setUnderlinePos = function() {
    var current = $('.current');

    // get current's position
    var width = current.outerWidth();
    var height = current.outerHeight();
    var offset = current.offset();
    const strokeWidth = 2;

    var headerHeight = $('#shopify-section-header').outerHeight();

    target.width(width);
    target.css('left', offset.left);
    target.css('top', offset.top + height - headerHeight - strokeWidth);
    target.css('opacity', 1);
  }



  var setProductsVisible = function(handle) {
    var sections = $('.shop-page-products');

    if (handle == 'all') {
      sections.show();
    } else {
      sections.each(function() {
        if ($(this).data('collection-handle') == handle) {
          $(this).show();
        } else {
          $(this).hide();
        }
      });
    }
  }

  if (target.length > 0) {
    // initial page load
    setUnderlinePos();
  }

  shopNavlinks.find('a').click(function() {
    // if (target.length == 0) return;

    shopNavlinks.removeClass('current');
    $(this).parent().addClass('current');
    // setUnderlinePos();
    setProductsVisible($('.current').data('link-for'));
    return false;
  });

  $('.nav-select').change(function() {
    setProductsVisible($(this).val());
    console.log($(this).val());
  })


  var inners = $('.inner');
  if (inners.length > 0) {
    TweenMax.set(inners, { autoAlpha: 0 });
  }

  /* image reveal */
  const imageRevealClass = 'image-reveal';
  const imageRevealSelector = '.' + imageRevealClass;

  var revealImagePrepare = function(selector) {
    var $els = $(selector);
    $els.each(function() {
      $el = $(this)
      if ($el.find('.outer').length) return;

      $img = $el.find('img');
      $el.append($('<div class="outer"><div class="inner">'));
      $el.find('.inner').append($img);
    });
  }

  revealImagePrepare(imageRevealSelector);

  var revealImage = function(container) {
    const outer = $(container).find('.outer')
    const inner = outer.find('.inner');
    const image = inner.find('img');
    const duration = 2;
  
    TweenMax.set(inner, { autoAlpha: 1 });
    //Expand outer Divs
    TweenMax.from(outer, duration, {x: '-100%', ease:Expo.easeInOut})
    TweenMax.from(inner, duration, {x:'100%', ease:Expo.easeInOut})
    //Slide the image in with the reveal
    TweenMax.from(image, duration, {x: -100, ease:Expo.easeInOut})
  }

  var slideUps = $('.slide-up');
  if (slideUps.length > 0) {
    TweenMax.set(slideUps, { autoAlpha: 0, y: 50 });
  }

  var revealSlideUp = function(el) {
    TweenMax.to(el, 1, { autoAlpha: 1, y: 0 });
  }




  
  


  /* split text and animate */
  
  var splitText = function(el, classToAdd) {
    var $el = $(el);
    var orig = $el.text();
    var newHtml = orig.split(/\s/).map(function(word) {
      return '<span>' + word + '</span>';
    }).join(' ');

    $el.html(newHtml);

    var lines = [];
    var line = '';
    var $spans = $el.find('span');
    var lastTop;
    for (var i = 0; i < $spans.length; i++) {
      $span = $spans.eq(i);
      if (!lastTop || lastTop != $span.offset().top) {
        // new line
        if (line) {
          lines.push(line);
        }

        lastTop = $span.offset().top;

        line = '';
          
      }

      if (i > 0) line += ' ';
      line += $span.text();
    }

    lines.push(line);

    var divsHtml = lines.map(function(l) {
      return '<div>' +  l + '</div>';
    }).join('');

    $divs = $(divsHtml);

    if (classToAdd) {
      $divs.addClass(classToAdd);
    }

    $el.empty().append($divs);
  }

  $('.text-split').each(function() {
    splitText(this, 'slide');
  });




  /* anim */

  var getItemAddClass = function(el, classToAdd) {
    return function() {
      $(el).addClass(classToAdd);
    }
  } 

  var animateSlides = function(container) {
    var $els = $(container).find('.slide');

    for (var i = 0; i < $els.length; i++) {
      var $el = $els.eq(i);
      var addClass = getItemAddClass($el, 'show');
      
      setTimeout(addClass, i*130 + 100);
    }
  }

  var $window = $(window);

  var elementIsVisible = function(el) {
    var $el = $(el);
    var top = $el.offset().top;

    return $window.scrollTop() + $window.height() > top + 50;
  }

  var animateVisibleSlides = function() {
    $('.slide-container').each(function(i, el) {
      var container = $(el);
      var visible = elementIsVisible(el);

      if (visible) animateSlides(container);
    });
  }

  animateVisibleSlides();

  var revealVisibleImages = function() {
    $(imageRevealSelector).each(function(i, el) {
      var container = $(el);
      var visible = elementIsVisible(el);

      if (visible) {
        revealImage(container);
        container.removeClass(imageRevealClass);
      }
    })
  }

  revealVisibleImages();

  const setHeaderTransparency = function() {
    const $el = $('#shopify-section-header');
    const opaqueClass = 'opaque';
    if ($window.scrollTop() < 50) {
      if ($el.hasClass(opaqueClass)) $el.removeClass(opaqueClass);

    } else {
      if (!$el.hasClass(opaqueClass)) $el.addClass(opaqueClass);
    }
  }

  setHeaderTransparency();

  $window.scroll(checkScroll);
  function checkScroll() {
      animateVisibleSlides();
      revealVisibleImages();
      setHeaderTransparency();
      // if ($(window).scrollTop() > $('body').height() / 2) {
      //   $('.modal-show-50').modal('show').removeClass('modal-show-50');
      // } 

      $('.slide-up').each(function(i, el) {
        var container = $(el);
        var visible = elementIsVisible(el);

        if (visible) {
          revealSlideUp(container);
          container.removeClass('slide-up');
        }
      });
  }

  $('.dropdown').hover(function() {
    animateSlides(this);
  }, function() {
    $(this).find('.slide').removeClass('show');
  });


  /* end split text and animte */


  $('.alert-dismissible button.close').click(function() {
    $(this).parent().slideUp();
  });


});


/* product recommendations */
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Read product id from data attribute
  var productId = productRecommendationsSection.dataset.productId;
  // Read base URL from data attribute
  var baseUrl = productRecommendationsSection.dataset.baseUrl;
  // Read limit from data attribute
  var limit = productRecommendationsSection.dataset.limit;
  // Build request URL
  var requestUrl = baseUrl + "?section_id=product-recommendations&product_id=" + productId + "&limit=" + limit;
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;

      $('[data-cart-submit=data-cart-submit]').submit(function() {
        showCart();
      });
    }
  };
  request.send();
};

// Listen for changes done in the Theme Editor
document.addEventListener("shopify:section:load", function(event) {
  if (event.detail.sectionId === "product-recommendations") {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

/* reviews */
var SPRCallbacks = {
  onProductLoad: function() {
    var sprSummary = $('.spr-summary');
    var starRating = sprSummary.find('.spr-summary-starrating');
    var summaryCaption = '(' + $('.spr-summary-caption').text().trim().replace('Based on ', '') + ')';

    $('.reviews-summary .star-rating').append(starRating);
    $('.reviews-summary .summary-caption').append(summaryCaption);

    $('.product-review-summary .star-rating').append(starRating.clone());
    $('.product-review-summary .summary-caption').append(summaryCaption);

    // $('.write-review-button').attr('onclick', $('.spr-summary-actions-newreview').attr('onclick'));
    // $('.spr-header').remove();

    // move review form to modal
    var reviewForm = $('.spr-form');
    $('#reviewFormModal .modal-body').append(reviewForm);
    reviewForm.show();
  },
  onReviewsLoad: function() {
    $('.spr-review-header').each(function() {
      var items = $(this).find('.spr-review-header-byline strong');
      var customerName = items.eq(0).text();
      var datePosted = items.eq(1).text();
      
      $(this).prepend('<div class="spr-date-posted">' + datePosted + '</div>');
      $(this).prepend('<div class="spr-customer-name">' + customerName + '</div>');
    });

    $('.spr-review-header-byline').remove();
    $('.spr-review-footer').remove();

    $('.spr-pagination-page a, .spr-pagination-next a, .spr-pagination-prev a').attr('onclick', 'SPR.pageReviews(this); return false');

    $('.spr-pagination-next a').text('').append('<i class="fa fa-angle-right"></i>');
    $('.spr-pagination-prev a').text('').append('<i class="fa fa-angle-left"></i>');

    var activePage = $('.spr-pagination-page.is-active').text();
    $('.spr-pagination-page.is-active').text('').append('<span>' + activePage + '</span>');
  },
  onFormLoad: function() {
    // replace submit button on review form
    var origBtn = $('.spr-form input[type=submit]');
    var newBtn = $('<button type="submit" class="btn btn-cut-outline review-submit" data-hover="Write Review"><div>Write Review</div></button>');

    origBtn.parent().append(newBtn);
    origBtn.remove();
  },
  onFormFailure: function() {
    // replace submit button on review form
    var origBtn = $('.spr-form input[type=submit]');
    var newBtn = $('<button type="submit" class="btn btn-cut-outline review-submit" data-hover="Write Review"><div>Write Review</div></button>');

    origBtn.parent().append(newBtn);
    origBtn.remove();
  }
}

/* carousel */
const owl = $('.owl-carousel');

if (owl.length) {
  owl.owlCarousel({
    loop:true,
    nav:false,
    dots: false,
    items: 1,
    mouseDrag: false,
    touchDrag: false,
    pullDrag: false,
    animateIn:'slideInDown',
    animateOut: 'slideOutDown'
  });
}


$('.carousel-nav-btn.nav-prev').click(function() {
  const owlOptions = owl.data('owl.carousel').options;
  owlOptions.animateIn = 'slideInDown';
  owlOptions.animateOut = 'slideOutDown';
  owl.trigger('refresh.owl.carousel');


  owl.trigger('prev.owl.carousel');
});

$('.carousel-nav-btn.nav-next').click(function() {
  const owlOptions = owl.data('owl.carousel').options;
  owlOptions.animateIn = 'slideInUp';
  owlOptions.animateOut = 'slideOutUp';
  owl.trigger('refresh.owl.carousel');

  owl.trigger('next.owl.carousel');
});

/* add to cart */
$('.add-to-cart-form').submit(function(e) {
  e.preventDefault();

  var $form = $(this);
  var id = $form.find('[name=id]').val();
  var qty = $form.find('[name=quantity]').val();
  
  var submit = $form.find('[type=submit]');
  submit.prop('disabled', true);

  var div = submit.find('div');
  div.text('Adding...');

  CartJS.addItem(id, qty, {}, {
    "success": function(data, textStatus, jqXHR) {
      div.text("Added!");
      setTimeout(function() {
        div.text(submit.data('hover'));
        submit.prop('disabled', false);
      }, 1000);
      showCart();
    },
    "error": function(jqXHR, textStatus, errorThrown) {
      div.text("Error");
      setTimeout(function() {
        div.text(submit.data('hover'));
        submit.prop('disabled', false);
      }, 1000);
    },
    "complete": function() {
      console.log("complete");
    }
  });
});

// Add slideDown animation to Bootstrap dropdown when expanding.
$('.dropdown').on('show.bs.dropdown', function() {
  $(this).find('.dropdown-menu').first().stop(true, true).slideDown();
});

// Add slideUp animation to Bootstrap dropdown when collapsing.
$('.dropdown').on('hide.bs.dropdown', function() {
  $(this).find('.dropdown-menu').first().stop(true, true).slideUp();
});